import React, { useState, useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';
import PaymentTermGrid from './grid';
import { RiRefreshLine } from "react-icons/ri";
import { FaSave } from "react-icons/fa";
import { hasPermission } from "../../services/roleService"
import Pagination from '../pagination/pagination';
import { GrEdit } from "react-icons/gr";
import { ClipLoader } from 'react-spinners';

const PaymentMaster = () => {
    const [permissions, setPermissions] = useState([]);
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [rowData, setRowData] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [load, setLoad] = useState(false);
    const apiService = new ApiService()

    const [formData, setFormData] = useState({
        recordId: "",
        PaymentCode: "",
        PaymentName: "",
    });

    useEffect(() => {
        fetchPaymentData();
        const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
        setPermissions(storedPermissions);
        if (pageSize) {
            fetchPaymentData();
        }
    }, [pageSize]);

    const checkPermission = (moduleName, action) => {
        return hasPermission(moduleName, action, permissions);
    };
    // const canEditMaster = checkPermission('Payment Master', 'edit');
    // const canCreateMaster = checkPermission('Payment Master', 'create');
    const canEditMaster = true;
    const canCreateMaster = true;

    const handleEdit = (clickedRowData) => {
        if (clickedRowData || selectedRow) {
            setFormData({
                recordId: clickedRowData?.record_Id || selectedRow?.record_Id,
                PaymentName: clickedRowData?.description || selectedRow?.description || "",
                PaymentCode: clickedRowData?.description_BI || selectedRow?.description_BI || "",
            });
        }
    };
    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const fetchPaymentData = async (newPageNo = pagination?.currentPage) => {
        try {
            const params = new URLSearchParams();
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', pageSize || 20);
            const response = await apiService.getApiParamater('GET_EPAYMENT', `?${params.toString()}`);
            setPagination(response.data.paginationData);
            setRowData(response?.data?.result);
        } catch (error) {
            console.error("Error fetching packing data:", error);
        }
    };
    const handleSubmit = async () => {
        setLoad(true)
        if (!formData.PaymentName || !formData.PaymentCode) {
            if (!formData.PaymentName) {
                toast.warning("Enter Payment Term Name")
                setLoad(false)
            }
            if (!formData.PaymentCode) {
                toast.warning("Enter Payment Term Code")
                setLoad(false)
            }
            return;
        }

        try {
            let data = {
                description: formData?.PaymentName,
                description_BI: formData?.PaymentCode,
                exp2: "1"
            }
            const response = await apiService.post('CREATE_EPAYMENT', data);
            if (response?.data?.statusCode === 201) {
                toast.success(response?.data?.message)
                setLoad(false)
                handleClearFilters()
            } else if (response?.data?.statusCode === 208) {
                setLoad(false)
                toast?.error(response?.data?.message)
            }
        } catch (error) {
            setLoad(false)
            toast.error("Please try Again!")
        }
    };
    const updateFormData = async () => {
        try {
            setLoad(true)
            let body = {
                record_Id: formData?.recordId,
                description: formData?.PaymentName,
                description_BI: formData?.PaymentCode,
            }
            const res = await apiService.put(`UPDATE_EPAYMENT`, body);

            if (res?.data?.statusCode === 201) {
                toast.success('Form data updated successfully');
                setLoad(false)
                handleClearFilters()
            } else {
                setLoad(false)
                console.error('Failed to update form data');
            }
        } catch (error) {
            setLoad(false)
            console.error('Error updating form data:', error);
        }
    };
    const handleClearFilters = () => {
        setFormData({
            recordId: "",
            PaymentCode: "",
            PaymentName: "",
        })
        fetchPaymentData()
        setLoad(false)
        setSelectedRow(null)
    };
    return (
        <div className='px-4 pt-3'>
         
            <div className='py-3'>
                <div className='gridBg p-3' style={{ borderRadius: "16px 16px 16px 16px" }}>
                <div className='d-flex justify-contant-between mb-4'>
                <h5 className='col mainInvHead'>Payment  Term Master</h5>
                <div className='d-flex justify-content-end gap-1'>
                    <div
                        onClick={handleEdit}
                        className={`mainbtnSecondary flex-end gap-2 ${!selectedRow ? 'disabled' : ''}`}
                        style={{ cursor: selectedRow ? 'pointer' : 'not-allowed' }}
                    >
                        <GrEdit color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Edit</div>
                    </div>
                    <div className=''>
                        {selectedRow ? (
                            <>{load === true ?
                                <button className='mainbtn '><ClipLoader size={30} color='#fff' /></button> :
                                <>
                                    {canEditMaster && (
                                        <button className='mainbtn ' onClick={updateFormData}>
                                            <FaSave className='center mt-1 mx-2' /> <div>Update</div></button>
                                    )}
                                </>
                            }
                            </>
                        ) : (
                            <>{load === true ?
                                <button className='mainbtn '><ClipLoader size={30} color='#fff' /></button> :
                                <>
                                    {canCreateMaster === true ?
                                        <button className='mainbtn ' onClick={handleSubmit}>
                                            <FaSave className='center mt-1 mx-2' /> <div>Save</div></button> :
                                        <button className='mainbtn disabled' style={{ cursor: "not-allowed" }}>
                                            <FaSave className='center mt-1 mx-2' /> <div>Save</div>
                                        </button>
                                    }
                                </>
                            }
                            </>
                        )}
                    </div>
                    <button className='mainbtnRed' onClick={handleClearFilters}><RiRefreshLine className='center mt-1 mx-2' /><div>Reset</div></button>
                </div>
            </div>
                    <div className="form-group row">
                        <div className="col-4 d-flex justify-content-between">
                            <label htmlFor="validationCustom01" className="form-label  pt-2 start">Payment term Code</label>
                            <input
                                type="text"
                                className="form-Input w-70"
                                id="validationCustom01"
                                disabled={canCreateMaster === true ? false : true}
                                name="PaymentCode"
                                value={formData.PaymentCode}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className="col-4 d-flex justify-content-between">
                            <label htmlFor="validationCustom02" className="form-label  pt-2 start">Payment Term Name</label>
                            <input
                                type="text"
                                className="form-Input w-70"
                                id="validationCustom02"
                                disabled={canCreateMaster === true ? false : true}
                                name="PaymentName"
                                value={formData?.PaymentName}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='gridBg pt-3'>
                <PaymentTermGrid fetchPaymentData={fetchPaymentData} rowData={rowData} canEditMaster={canEditMaster}
                    setSelectedRow={setSelectedRow} handleEdit={handleEdit} />
                <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={fetchPaymentData} />
            </div>

        </div>
    )
}

export default PaymentMaster;
